
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Circle } from "lucide-react";

interface UserStatusBadgeProps {
  isOnline: boolean;
  className?: string;
}

const UserStatusBadge = ({ isOnline, className = "" }: UserStatusBadgeProps) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Circle 
        className={`h-3 w-3 ${isOnline ? 'fill-green-500 text-green-500' : 'fill-gray-400 text-gray-400'}`}
      />
      <Badge 
        variant={isOnline ? "default" : "secondary"}
        className={isOnline ? "bg-green-100 text-green-800 border-green-200" : ""}
      >
        {isOnline ? "Online" : "Offline"}
      </Badge>
    </div>
  );
};

export default UserStatusBadge;
